import { render } from "./InputModal.vue?vue&type=template&id=4cd12b64&scoped=true"
import script from "./InputModal.vue?vue&type=script&lang=js"
export * from "./InputModal.vue?vue&type=script&lang=js"

import "./InputModal.vue?vue&type=style&index=0&id=4cd12b64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd12b64"]])

export default __exports__